export const primaryColor = localStorage.getItem("primaryColor") || "#0051ff";
export const secondaryColor = localStorage.getItem("secondaryColor") || "#ff0000";
export const mode = localStorage.getItem("mode") || "light";
export function getContrastingTextColor(hexColor = "") {
  const hex = hexColor?.replace("#", "") || "";
  const r = parseInt(hex?.substring(0, 2), 16);
  const g = parseInt(hex?.substring(2, 4), 16);
  const b = parseInt(hex?.substring(4, 6), 16);
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;

  return brightness > 128 ? "#000000" : "#ffffff";
}
